import { alpha, ListItem, styled } from '@mui/material';

type StyledListItemProps = {
    equalWidth?: boolean
}

const StyledListItem = styled(ListItem)<StyledListItemProps>(({ theme, equalWidth }) => ({
    '.MuiListItemText-root': equalWidth && {
        flex: '1 1 0',
    },
    '&:hover': {
        cursor: 'pointer',
        backgroundColor: alpha(theme.palette.common.black, 0.05),
    },
}));

export default StyledListItem;
